import { useRefinementList, useClearRefinements } from 'react-instantsearch';
import { trackEvent } from '../../utils/analytics';
import { useIdentity } from '../../hooks';
import { isEmpty, difference } from 'lodash';
import MultiSelectFilter from '../product-search/shared/MultiSelectFilter';

function CustomMenuSelect({ label, ...props }) {
  const { items, refine } = useRefinementList(props);
  const { refine: clearRefine } = useClearRefinements({
    includedAttributes: [props.attribute],
  });
  const identity = useIdentity();

  const handleChange = (event) => {
    const selectedValues = Array.isArray(event) ? event.map(o => o.value) : [];
    if (isEmpty(selectedValues)) {
      clearRefine();
      return;
    }

    const currentValues = items.filter(i => i.isRefined).map(i => i.value);

    const added = difference(selectedValues, currentValues);
    const removed = difference(currentValues, selectedValues);

    if (!isEmpty(added)) {
      trackEvent(`click_${props.attribute}_filter`, {
        tenant_id: identity.tenant_id,
        login_email: identity.login_email,
        [props.attribute]: added[0],
      });
      refine(added[0]);
    } else if (!isEmpty(removed)) {
      refine(removed[0]);
    }
  };

  const options = [
    ...items
      .map((item) => ({
        value: item.value,
        label: `${item.value} (${item.count})`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];

  return (
    <MultiSelectFilter
      label={label}
      options={options}
      value={options.filter(o => items.some(i => i.isRefined && i.value === o.value))}
      onChange={handleChange}
      isClearable={items.some(i => i.isRefined)}
    />
  );
}

export default CustomMenuSelect;
